module.exports = __webpack_public_path__ + "images/background/image_thumbnail/2-off-e5f6376f475e6f096ce6586c17091957.jpg";